import VueSelect from "./components/Select";
import mixins from "./mixins/index";

export default VueSelect;
export { VueSelect, mixins };
